"use client";
import React from "react";

export default function FAQ({ data }) {
  return (
    <section className="new-section">
      <div className="new-section-title">
        <h2>Frequently Asked Questions</h2>
        <p>
          Here are some of the most frequently asked questions about this
          machine. If you have a question that is not answered here, please
          contact us.
        </p>
      </div>
      <div className="new-section-content-wrapper faq">
        {data.map((faq) => (
          <div className="faq" key={faq.id}>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
